import { render, staticRenderFns } from "./brandCategory.vue?vue&type=template&id=1f8c6a2d&scoped=true&"
import script from "./brandCategory.vue?vue&type=script&lang=js&"
export * from "./brandCategory.vue?vue&type=script&lang=js&"
import style0 from "./brandCategory.vue?vue&type=style&index=0&id=1f8c6a2d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8c6a2d",
  null
  
)

export default component.exports